import { useAppContext } from "app/AppContext";
import firebaseUtil from "firebaseUtil";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Home from "./Home";
import RoutesMenusGrupo from "./Grupo";
import RoutesMenusPerfil from "./Perfil";
import RoutesMenusProduto from "./Produto";
import RoutesMenusRodada from "./Rodada";
import RoutesMenusInscricao from "./Inscricao";
import RoutesMenusReuniao from "./Reuniao";
import PublicRodadaList from "entity/Rodada/components/PublicRodadaList";

export default function RoutesMenusPrivate() {
    const navigate = useNavigate();

    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();
    console.log('Private config')

    useEffect(() => {
        addMenu({
            uid: "Inicio",
            text: "Início",
            iconName: "Home",
            sequence: "0",
            action: () => {
                navigate("/");
            },
        });

        addRoute({ uid: "homeauth", title: "Início", route: "/", element: <Home /> });

        addMenu({
            uid: "InicioPublic",
            text: "Início Público",
            iconName: "Home",
            sequence: "0",
            action: () => {
                navigate("/publicHome");
            },
        });

        addRoute({ uid: "InicioPublic", title: "Início Público", route: "/publicHome", element: <PublicRodadaList/> });

        addMenu({
            uid: "sair",
            text: "Sair",
            iconName: "ExitToApp",
            sequence: "999999",
            action: () => {
                firebaseUtil.logout();
                navigate("/login");
            },
        });

        return () => {
            // console.log("remove buttoms private");
            removeMenusRoutes(["Inicio", "homeauth", "sair"]);
        };
    }, [addMenu, addRoute, navigate, removeMenusRoutes]);

    return (
        <>
            <RoutesMenusReuniao />{/*sequence: "000001", */}
            <RoutesMenusRodada />{/*sequence: "000002", */}
            <RoutesMenusGrupo />{/*sequence: "000005", */}
            <RoutesMenusProduto />{/*sequence: "000006", */}
            <RoutesMenusInscricao />{/*sequence: "000007", */}
            <RoutesMenusPerfil />{/*sequence: "000008", */}
        </>
    );
}
